const pageRouteNames = {
  COURSE: "training",
};

export default pageRouteNames;
